import React, {
  createContext,
  useCallback,
  useEffect,
  useState,
} from 'react';
import posthog from 'posthog-js';
import { getAPI } from 'src/api';
import { ListingWhoAmIResponse } from 'src/generated/api';
import { analytics } from 'src/analytics';

interface ListingAuthContextInterface {
  user: ListingWhoAmIResponse | null;
  refetch: () => Promise<void>;
}

export const ListingAuthContext = createContext<ListingAuthContextInterface>({
  user: null,
  refetch: async () => { },
});

interface Props {
  children: React.ReactNode | React.ReactNode[];
}

export function ListingAuthContextProvider({ children }: Props) {
  const [user, setUser] = useState<ListingWhoAmIResponse | null>(null);
  const api = getAPI();
  const fetchAuth = useCallback(async () => {
    try {
      const res = await api.listings.me();
      setUser(res.data);
    } catch (err) {
      // Do nothing
    }
  }, [api]);
  useEffect(() => { fetchAuth(); }, [fetchAuth]);
  useEffect(() => {
    if (user) {
      posthog.identify(user.emailAddress);
      analytics.identify(user.emailAddress);
    }
  }, [user]);
  return (
    <ListingAuthContext.Provider value={{
      user,
      refetch: fetchAuth,
    }}>
      {children}
    </ListingAuthContext.Provider>
  );
}
